import { useQuery, UseQueryResult } from "@tanstack/react-query";
import {
  getMediaItemsWithTasks,
  MediaItemTask,
} from "@coworker/apprestructured/src/task-management/services/tasks.service";
import { getMediaItemsWithTasksQueryKey } from "@coworker/apprestructured/src/task-management/services/queryKeyHelper";

/**
 * Fetch items with v2 tasks in a specific media
 * Uses endpoint: GET /tasks-v2/items?media_id=&task_type_ids=&state=
 * Returns: Array of { article_id, item_no } pairs
 */
export function useMediaItemsWithTasks(
  mediaId: string | undefined,
  taskTypeIds: string[]
): UseQueryResult<MediaItemTask[]> {
  return useQuery({
    queryKey: getMediaItemsWithTasksQueryKey(mediaId, taskTypeIds),
    queryFn: async () => {
      if (!mediaId || taskTypeIds.length === 0) {
        return [];
      }

      return await getMediaItemsWithTasks(mediaId, taskTypeIds);
    },
    enabled: !!mediaId && taskTypeIds.length > 0,
    staleTime: 30000, // 30 seconds
    gcTime: 60000, // 60 seconds
  });
}
